<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <component-header
          title="Edit Tax Code"
          :hasSearch="false"
          :hasReload="false"
          :hasCreate="false"
          :hasback="true"
          @back-press="$router.push({ name: 'Taxcode' })"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="Object.keys(details).length">
      <b-col>
        <b-card>
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <b-row>
              <b-col md="12">
                <div slot="header"></div>
                <b-row class="font-md">
                  <b-col md="6">
                    <div class="form-group">
                      <span>Tax Code</span>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Tax code"
                      >
                        <input class="form-control" v-model="details.taxCode" />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="6">
                    <div class="form-group">
                      <span>Country</span>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Country"
                      >
                        <input class="form-control" v-model="details.country" />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="font-md">
                  <b-col md="6">
                    <div class="form-group">
                      <span>Start Date</span>
                      <ValidationProvider
                        rules="required|futureDisable"
                        v-slot="{ errors }"
                        name="start-date"
                      >
                        <b-input
                          id="start-date"
                          type="date"
                          v-model="details.startDate"
                        ></b-input>
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="6">
                    <div class="form-group">
                      <span>End Date</span>
                      <ValidationProvider
                        rules="required|futureDisable|afterDate:start-date"
                        v-slot="{ errors }"
                        name="end-date"
                      >
                        <b-input
                          id="end-date"
                          type="date"
                          v-model="details.endDate"
                        ></b-input>
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
                <div
                  v-for="(data, idx) in details.restData.details"
                  :key="idx"
                  class="mt-4"
                >
                  <b-col
                    v-for="(taxLine, lIdx) in details.restData.details[idx]
                      .taxLines"
                    :key="lIdx"
                  >
                    <b-row>
                      <b-col md="9">
                        <b-row>
                          <b-col md="4">
                            <div class="form-group">
                              <label for="start-date">Tax Line Name</label>
                              <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Tax line name"
                              >
                                <b-input
                                  id="start-date"
                                  type="text"
                                  v-model="taxLine.taxLineName"
                                ></b-input>
                                <span class="validate-error">{{
                                  errors[0]
                                }}</span>
                              </ValidationProvider>
                            </div>
                          </b-col>
                          <b-col md="4">
                            <div class="form-group">
                              <label for="start-date">Tax Rate</label>
                              <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Tax rate"
                              >
                                <b-input
                                  id="start-date"
                                  type="text"
                                  v-model="taxLine.taxRates[0].tax"
                                ></b-input>
                                <span class="validate-error">{{
                                  errors[0]
                                }}</span>
                              </ValidationProvider>
                            </div>
                          </b-col>
                          <b-col md="4" class="mb-3">
                            <div class="form-group">
                              <label for="start-date">Tax Line Type</label>
                              <eb-select
                                type="select"
                                :selected="taxLine.taxRates[0].rateType"
                                :options="['P']"
                                v-model="taxLine.taxRates[0].rateType"
                                label="text"
                                id="start-date"
                              ></eb-select>
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col md="3" class="btns-div">
                        <b-button
                          variant="primary"
                          size="sm"
                          @click="removeTaxLime(idx, lIdx)"
                          v-if="
                            details.restData.details[idx].taxLines.length > 1
                          "
                        >
                          Remove
                          <i class="fa fa-minus-circle"></i>
                        </b-button>
                        <b-button
                          variant="primary"
                          size="sm"
                          @click="addTaxLines(idx)"
                          v-if="
                            details.restData.details[idx].taxLines.length -
                              1 ===
                            lIdx
                          "
                        >
                          Add Item
                          <i class="fa fa-plus-circle"></i>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </div>
                <b-row class="p-2">
                  <b-col md="12">
                    <div class="text-center">
                      <eb-button
                        class="btn"
                        classic="mr-1 btn-primary"
                        text="Update"
                        @click.prevent="handleSubmit"
                      ></eb-button>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </ValidationObserver>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import ebButton from "@/components/FormElements/Button";
import TaxCodeDetails from "@/components/MasterSetup/TaxCode/TaxCodeDetails.vue";
import moment from "moment";
import ebSelect from "@/components/FormElements/Select.vue";
import ComponentHeader from "@/components/componentNewHeader";
import {
  ValidationObserver,
  ValidationProvider,
  Validator,
} from "vee-validate";

export default {
  name: "editfaq",
  components: {
    ebButton,
    cInput,
    TaxCodeDetails,
    ebSelect,
    ComponentHeader,
    ValidationObserver,
    ValidationProvider,
  },
  data: () => {
    return {
      show: true,
      taxCode: "",
      country: "",
      startDate: 0,
      endDate: 0,
      taxLines: [
        {
          taxLineName: "",
          taxRates: [
            {
              rangeStart: 0,
              rangeEnd: 0,
              rateType: "",
              tax: 0,
            },
          ],
        },
      ],
      details: {},
    };
  },
  // props: {
  //   details: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    onClickTaxline(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable) {
        this.inputObject.details.map((obj) => {
          if (obj.btnText === "Add Line") {
            obj.btnText = "Remove";
            obj.isRemovable = true;
            obj.id = idx + 1;
          }
        });
        this.inputObject.details.push({
          shipFrom: "nil",
          shipTo: "nil",
          billTo: "nil",
          taxLines: [
            {
              taxLineName: "",
              taxRates: [
                {
                  rangeStart: 0,
                  rangeEnd: 0,
                  rateType: "",
                  tax: 0,
                },
              ],
            },
          ],
          btnText: "Add Line",
          isRemovable: false,
          id: this.inputObject.details.length + 1,
        });
        this.inputObject.details.sort((a, b) =>
          a.btnText > b.btnText ? -1 : b.btnText > a.btnText ? 1 : 0
        );
      } else this.inputObject.details.splice(idx, 1);
    },
    addTaxLines(index) {
      this.details.restData.details[index].taxLines.push({
        taxLineName: "",
        taxRates: [
          {
            rangeStart: 0,
            rangeEnd: 0,
            rateType: "",
            tax: 0,
          },
        ],
      });
    },
    removeTaxLime(detailIndex, lineIndex) {
      this.details.restData.details[detailIndex].taxLines.splice(lineIndex, 1);
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let payload = {
        _id: this.details.restData._id,
        country: this.details.country,
        startDate: moment(this.details.startDate).toDate().getTime(),
        endDate: moment(this.details.endDate).toDate().getTime(),
        taxCode: this.details.taxCode,
        details: this.details.restData.details,
      };

      await this.$store.dispatch("taxcode/updateTaxcode", payload).then(() => {
        this.$swal({
          title: "Success",
          text: "Taxcode updated successfully!!",
          type: "success",
        });
      });
      this.$router.push({ name: "Taxcode" });
    },
  },
  async mounted() {
    this.details = { ...this.$route.params.data };
    this.details.startDate = moment(
      this.details.startDate,
      "DD/MM/yyyy"
    ).format("yyyy-MM-DD");
    this.details.endDate = moment(this.details.endDate, "DD/MM/yyyy").format(
      "yyyy-MM-DD"
    );
    await Validator.extend(
      "afterDate",
      (value, [otherValue]) => {
        return moment(value).diff(this.details.startDate, "hour") >= 0;
      },
      {
        hasTarget: true,
      }
    );
    await Validator.extend(
      "futureDisable",
      (value, [otherValue]) => {
        return moment().diff(this.details.startDate, "hour") >= 0;
      },
      {
        hasTarget: true,
      }
    );
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
.btns-div {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
}
</style>
